// import React, { useState, Fragment, useEffect, useRef } from "react";
// import { Table, Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_blue.css";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
//   flexRender,
// } from "@tanstack/react-table";
// import { FixedSizeList as List } from "react-window";
// import AutoSizer from "react-virtualized-auto-sizer";
// import { showToast } from "../ToastNotification";

// const TableContainerDateRangeFilter3 = ({
//   footer,
//   summary,
//   columns,
//   data,
//   theadClass = "",
//   tbodyClass = "",
//   onDateRangeChange,
//   type,
// }) => {
//   const [globalFilter, setGlobalFilter] = useState("");
//   const [summaryData, setSummarydata] = useState(summary);
//   const [sorting, setSorting] = useState([]);
//   const [dateRange, setDateRange] = useState([]);
//   const [tableLoading, setTableLoading] = useState(false);
//   const tableContainerRef = useRef(null);
//   const headerRef = useRef(null);

//   // Default row height - adjust based on your design
//   const ROW_HEIGHT = 48;

//   const convertToDateFormat = (dateString) => {
//     const months = {
//       Jan: "01",
//       Feb: "02",
//       Mar: "03",
//       Apr: "04",
//       May: "05",
//       Jun: "06",
//       Jul: "07",
//       Aug: "08",
//       Sep: "09",
//       Oct: "10",
//       Nov: "11",
//       Dec: "12",
//     };

//     const [day, month, year] = dateString.replace(",", "").split(" ");
//     return `${day.padStart(2, "0")}-${months[month]}-${year}`;
//   };

//   const table = useReactTable({
//     columns,
//     data,
//     getCoreRowModel: getCoreRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//     state: {
//       globalFilter,
//       sorting,
//     },
//     onGlobalFilterChange: setGlobalFilter,
//     onSortingChange: setSorting,
//   });

//   const initialRange =
//     summary?.start && summary?.end
//       ? [convertToDateFormat(summary?.start), convertToDateFormat(summary?.end)]
//       : [];

//   const handleApplyClick = () => {
//     const filteredArr = dateRange.filter((item) => item !== null);
//     if (filteredArr?.length > 1) {
//       setTableLoading(true);
//       if (onDateRangeChange) {
//         const formatDate = (date) => {
//           return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(2, "0")}-${String(date?.getDate()).padStart(2, "0")}`;
//         };

//         onDateRangeChange({
//           start_date: formatDate(dateRange[0]),
//           end_date: formatDate(dateRange[1]),
//           setTableLoading,
//         });
//       }
//     } else {
//       showToast("Please select a date range to filter", "error");
//     }
//   };

//   useEffect(() => {
//     const rows = table.getRowModel().rows;
//     if (rows.length > 0) {
//       if(type==='CAP'){

//         const totals = rows.reduce(
//           (acc, item) => {
//             acc.total_purchase += +item?.original.debit || 0;
//             acc.total_sale += +item?.original.credit || 0;
//             return acc;
//           },
//           {
//             total_purchase: 0,
//             total_sale: 0,
//             start: summary?.start,
//             end: summary?.end,
//           }
//         );
//         setSummarydata(totals);
//       }else {
//         const totals = rows.reduce(
//           (acc, item) => {
//             acc.total_debit += +item?.original.debit || 0;
//             acc.total_credit += +item?.original.credit || 0;
//             return acc;
//           },
//           {
//             total_debit: 0,
//             total_credit: 0,
//             start: summary?.start,
//             end: summary?.end,
//           }
//         );
//         setSummarydata(totals);
//       }
//       // setSummarydata(totals);
//     }
//   }, [table.getRowModel, globalFilter, tableLoading, summary]);

//   // Calculate column widths once and reuse
//   const columnWidths = [];

//   // Calculate the total number of columns
//   const columnCount = table.getAllColumns().length;

//   // Calculate widths for each column - using percentage for better alignment
//   table.getAllColumns().forEach((column, index) => {
//     // Default to even distribution if no size specified
//     const widthPercentage = column.columnDef.size || (100 / columnCount);
//     columnWidths[index] = `${widthPercentage}%`;
//   });

//   // Row renderer for virtualized list
//   const Row = ({ index, style }) => {
//     const row = table.getRowModel().rows[index];
//     return (
//       <div
//         className="tr"
//         style={{
//           ...style,
//           display: "flex",
//           width: "100%",
//           borderBottom: "1px solid #e9ecef"
//         }}
//       >
//         {row?.getVisibleCells()?.map((cell, cellIndex) => (
//           <div
//             key={cell.id}
//             className="td fs-p-bg fw-medium"
//             style={{
//               width: columnWidths[cellIndex],
//               padding: "0.75rem",
//               borderRight: cellIndex < columnCount - 1 ? "1px solid #e9ecef" : "none",
//               textAlign: cell.column.columnDef.bodyTextAlign || "left",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap"
//             }}
//           >
//             {flexRender(cell.column.columnDef.cell, cell.getContext())}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   // Empty state component
//   const EmptyState = () => (
//     <Card className="m-0 text-muted">
//       <CardBody>No Record Found</CardBody>
//     </Card>
//   );

//   // Handle horizontal scroll synchronization
//   const handleTableScroll = (e) => {
//     if (headerRef.current) {
//       headerRef.current.scrollLeft = e.target.scrollLeft;
//     }
//   };

//   return (
//     <Fragment>
//       {/* Search and Date Filter */}
//       <Row className="mb-2" ref={tableContainerRef}>
//         <div className="search-box d-inline-block col-xxl-6 col-lg-12 col-12 mb-xxl-0 mb-lg-2 mb-2">
//           <input
//             id="search-bar-0"
//             type="text"
//             style={{
//               backgroundColor: "#F1F4F7",
//               border: "1px solid transparent",
//             }}
//             className="form-control border-0 search"
//             placeholder="Search..."
//             value={globalFilter}
//             onChange={(e) => setGlobalFilter(e.target.value)}
//           />
//           <i className="bx bx-search-alt search-icon"></i>
//         </div>
//         <div className="date-box d-inline-block col-xxl-4 col-lg-8 col-8">
//           <Flatpickr
//             style={{
//               backgroundColor: "#F1F4F7",
//               border: "1px solid transparent",
//             }}
//             options={{ mode: "range", dateFormat: "d-m-Y", maxDate: "today" }}
//             value={dateRange.length > 1 ? dateRange : initialRange}
//             onChange={setDateRange}
//             className="form-control"
//           />
//           <i className="bx bx-calendar date-icon"></i>
//         </div>
//         <div className="col-xxl-2 col-lg-4 col-4">
//           <button className="btn btn-primary w-100" onClick={handleApplyClick}>
//             Apply
//           </button>
//         </div>
//       </Row>

//       {/* Table Container */}
//       <div
//         className="table-responsive table-container"
//         ref={tableContainerRef}
//         style={{
//           height: "500px",
//           border: "1px solid #e9ecef",
//           borderRadius: "4px",
//           overflow: "hidden"
//         }}
//       >
//         {tableLoading ? (
//           <Card className="m-0 text-muted h-100">
//             <CardBody className="d-flex align-items-center justify-content-center h-100">
//               <Spinner color="primary" />
//             </CardBody>
//           </Card>
//         ) : (
//           <div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>
//             {/* Table Header */}
//             <div
//               ref={headerRef}
//               className={`thead bg-gl-primary sticky-header ${theadClass}`}
//               style={{
//                 display: "flex",
//                 width: "100%",
//                 borderBottom: "1px solid #e9ecef",
//                 overflow: "hidden"
//               }}
//             >
//               {table.getHeaderGroups().map((headerGroup) => (
//                 <div key={headerGroup.id} style={{ display: "flex", width: "100%" }}>
//                   {headerGroup.headers.map((header, index) => {
//                     const isSorted = header.column.getIsSorted();
//                     return (
//                       <div
//                         key={header.id}
//                         className="th"
//                         style={{
//                           width: columnWidths[index],
//                           padding: "0.75rem",
//                           fontWeight: "bold",
//                           color: "#fff",
//                           borderRight: index < columnCount - 1 ? "1px solid rgba(255,255,255,0.2)" : "none",
//                           textAlign: header.column.columnDef.headerTextAlign || "left",
//                           cursor: "pointer",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           whiteSpace: "nowrap"
//                         }}
//                         onClick={header.column.getToggleSortingHandler()}
//                       >
//                         <div className="d-flex align-items-center justify-content-between">
//                           {flexRender(
//                             header.column.columnDef.Header,
//                             header.getContext()
//                           )}
//                           {isSorted === "asc" ? (
//                             <i className="ms-2 bx bx-caret-up"></i>
//                           ) : isSorted === "desc" ? (
//                             <i className="ms-2 bx bx-caret-down"></i>
//                           ) : (
//                             <i className="ms-2 bx bxs-sort-alt"></i>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               ))}
//             </div>

//             {/* Virtualized Table Body */}
//             <div
//               style={{
//                 height: footer ? "calc(100% - 96px)" : "calc(100% - 48px)",
//                 overflow: "auto"
//               }}
//               onScroll={handleTableScroll}
//             >
//               {data?.length > 0 && table.getRowModel()?.rows?.length > 0 ? (
//                 <AutoSizer>
//                   {({ height, width }) => (
//                     <List
//                       height={height}
//                       itemCount={table.getRowModel().rows.length}
//                       itemSize={ROW_HEIGHT}
//                       width={width}
//                       className={`tbody ${tbodyClass}`}
//                     >
//                       {Row}
//                     </List>
//                   )}
//                 </AutoSizer>
//               ) : (
//                 <div className="d-flex justify-content-evenly align-items-center align-items-center h-100">
//                   <EmptyState />
//                 </div>
//               )}
//             </div>

//             {/* Table Footer */}
//             {footer && type==='CAP' ?  (
//               <div
//                 className="tfoot table-footer sticky-footer"
//                 style={{
//                   display: "flex",
//                   width: "100%",
//                   borderTop: "1px solid #e9ecef"
//                 }}
//               >
//                 <div className="tr bg-gl-success" style={{ display: "flex", width: "100%" }}>
//                   <div
//                     className="th"
//                     style={{
//                       width: `calc(${columnWidths[0]} + ${columnWidths[1]} + ${columnWidths[2]} + ${columnWidths[3]} + ${columnWidths[4]})`,
//                       textAlign: "end",
//                       padding: "0.75rem",
//                       borderRight: "1px solid rgba(255,255,255,0.2)"
//                     }}
//                   >
//                     Total
//                   </div>
//                   <div
//                     className="th"
//                     style={{
//                       width: columnWidths[5],
//                       textAlign: "end",
//                       padding: "0.75rem",
//                       borderRight: "1px solid rgba(255,255,255,0.2)"
//                     }}
//                   >
//                     {parseFloat(summaryData?.total_purchase ?? 0).toLocaleString("en-IN")}
//                   </div>
//                   <div
//                     className="th"
//                     style={{
//                       width: columnWidths[6],
//                       textAlign: "end",
//                       padding: "0.75rem",
//                       borderRight: "1px solid rgba(255,255,255,0.2)"
//                     }}
//                   >
//                   </div>
//                   <div
//                     className="th"
//                     style={{
//                       width: columnWidths[7],
//                       textAlign: "end",
//                       padding: "0.75rem",
//                       borderRight: "1px solid rgba(255,255,255,0.2)"
//                     }}
//                   >
//                     {parseFloat(summaryData?.total_sale ?? 0).toLocaleString("en-IN")}
//                   </div>
//                   <div
//                     className="th"
//                     style={{
//                       width: columnWidths[8],
//                       textAlign: "end",
//                       padding: "0.75rem",
//                       borderRight: "1px solid rgba(255,255,255,0.2)"
//                     }}
//                   >
//                   </div>
//                   <div
//                     className="th"
//                     style={{
//                       width: columnWidths[9],
//                       textAlign: "end",
//                       padding: "0.75rem"
//                     }}
//                   >
//                   </div>
//                 </div>
//               </div>
//             ) : footer ?
//             <div
//             className="tfoot table-footer sticky-footer"
//             style={{
//               display: "flex",
//               width: "100%",
//               borderTop: "1px solid #e9ecef"
//             }}
//           >
//             <div className="tr bg-gl-success" style={{ display: "flex", width: "100%" }}>
//               <div
//                 className="th"
//                 style={{
//                   width: `calc(${columnWidths[0]} + ${columnWidths[1]} + ${columnWidths[2]} + ${columnWidths[3]} + ${columnWidths[4]} + ${columnWidths[5]} + ${columnWidths[6]} + ${columnWidths[7]})`,
//                   textAlign: "end",
//                   padding: "0.75rem",
//                   borderRight: "1px solid rgba(255,255,255,0.2)"
//                 }}
//               >
//                 Total
//               </div>
//               <div
//                 className="th"
//                 style={{
//                   width: columnWidths[8],
//                   textAlign: "end",
//                   padding: "0.75rem",
//                   borderRight: "1px solid rgba(255,255,255,0.2)"
//                 }}
//               >
//                 {parseFloat(summaryData?.total_debit ?? 0).toLocaleString("en-IN")}
//               </div>

//               <div
//                 className="th"
//                 style={{
//                   width: columnWidths[9],
//                   textAlign: "end",
//                   padding: "0.75rem",
//                   borderRight: "1px solid rgba(255,255,255,0.2)"
//                 }}
//               >
//                 {parseFloat(summaryData?.total_credit ?? 0).toLocaleString("en-IN")}
//               </div>

//             </div>
//           </div> : null}
//           </div>
//         )}
//       </div>
//     </Fragment>
//   );
// };

// export default TableContainerDateRangeFilter3;

// import React, { useState, Fragment, useEffect, useRef, useMemo } from "react";
// import { Table, Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_blue.css";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
//   flexRender,
// } from "@tanstack/react-table";
// import { FixedSizeList as List } from "react-window";
// import AutoSizer from "react-virtualized-auto-sizer";
// import { showToast } from "../ToastNotification";

// const TableContainerDateRangeFilter3 = ({
//   footer,
//   summary,
//   columns,
//   data,
//   theadClass = "",
//   tbodyClass = "",
//   onDateRangeChange,
// }) => {
//   const [globalFilter, setGlobalFilter] = useState("");
//   const [summaryData, setSummarydata] = useState(summary);
//   const [sorting, setSorting] = useState([]);
//   const [dateRange, setDateRange] = useState([]);
//   const [tableLoading, setTableLoading] = useState(false);
//   const tableContainerRef = useRef(null);
//   const [tableWidth, setTableWidth] = useState(0);

//   // Default row height
//   const ROW_HEIGHT = 48;
//   // Minimum column width
//   const MIN_COLUMN_WIDTH = 120;

//   const convertToDateFormat = (dateString) => {
//     const months = {
//       Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
//       Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
//     };

//     const [day, month, year] = dateString.replace(",", "").split(" ");
//     return `${day.padStart(2, "0")}-${months[month]}-${year}`;
//   };

//   const table = useReactTable({
//     columns,
//     data,
//     getCoreRowModel: getCoreRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//     state: {
//       globalFilter,
//       sorting,
//     },
//     onGlobalFilterChange: setGlobalFilter,
//     onSortingChange: setSorting,
//   });

//   const initialRange =
//     summary?.start && summary?.end
//       ? [convertToDateFormat(summary?.start), convertToDateFormat(summary?.end)]
//       : [];

//   const handleApplyClick = () => {
//     const filteredArr = dateRange.filter((item) => item !== null);
//     if (filteredArr?.length > 1) {
//       setTableLoading(true);
//       if (onDateRangeChange) {
//         const formatDate = (date) => {
//           return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(2, "0")}-${String(date?.getDate()).padStart(2, "0")}`;
//         };

//         onDateRangeChange({
//           start_date: formatDate(dateRange[0]),
//           end_date: formatDate(dateRange[1]),
//           setTableLoading,
//         });
//       }
//     } else {
//       showToast("Please select a date range to filter", "error");
//     }
//   };

//   useEffect(() => {
//     const rows = table.getRowModel().rows;
//     if (rows.length > 0) {
//       const totals = rows.reduce(
//         (acc, item) => {
//           acc.total_purchase += +item?.original.debit || 0;
//           acc.total_sale += +item?.original.credit || 0;
//           return acc;
//         },
//         {
//           total_purchase: 0,
//           total_sale: 0,
//           start: summary?.start,
//           end: summary?.end,
//         }
//       );
//       setSummarydata(totals);
//     }
//   }, [table.getRowModel, globalFilter, tableLoading, summary]);

//   // Compute fixed column widths once for all sections
//   const columnWidths = useMemo(() => {
//     const computedWidths = [];
//     const allColumns = table.getAllColumns();

//     // First, calculate total width and sizes
//     let totalSize = 0;
//     allColumns.forEach(column => {
//       const size = column.columnDef.size || 1;
//       totalSize += size;
//     });

//     // Then calculate actual widths
//     allColumns.forEach(column => {
//       const minWidth = column.columnDef.minSize || MIN_COLUMN_WIDTH;
//       const size = column.columnDef.size || 1;
//       // Fixed width calculation based on proportion and minimum width
//       computedWidths.push({
//         id: column.id,
//         minWidth,
//         width: `${minWidth}px`,
//         flex: size,
//       });
//     });

//     return computedWidths;
//   }, [table.getAllColumns()]);

//   // Set table width based on container
//   useEffect(() => {
//     if (tableContainerRef.current) {
//       setTableWidth(tableContainerRef.current.clientWidth);
//     }
//   }, []);

//   // Empty state component
//   const EmptyState = () => (
//     <Card className="m-0 text-muted">
//       <CardBody>No Record Found</CardBody>
//     </Card>
//   );

//   return (
//     <Fragment>
//       {/* Search and Date Filter */}
//       <div className="mb-3 row">
//         <Col xs="12" lg="12" xxl="6" className="mb-2 mb-xxl-0">
//           <div className="search-box position-relative d-inline-block w-100">
//             <input
//               id="search-bar-0"
//               type="text"
//               className="form-control"
//               style={{
//                 backgroundColor: "#F1F4F7",
//                 border: "1px solid #ced4da",
//                 height: "38px",
//                 paddingLeft: "2.5rem"
//               }}
//               placeholder="Search..."
//               value={globalFilter}
//               onChange={(e) => setGlobalFilter(e.target.value)}
//             />
//             <i className="bx bx-search-alt search-icon" style={{
//               position: "absolute",
//               left: "1rem",
//               top: "50%",
//               transform: "translateY(-50%)",
//               color: "#6c757d"
//             }}></i>
//           </div>
//         </Col>
//         <div className="date-box d-inline-block col-xxl-4 col-lg-8 col-8">
//           <Flatpickr
//             style={{
//               backgroundColor: "#F1F4F7",
//               border: "1px solid transparent",
//             }}
//             options={{ mode: "range", dateFormat: "d-m-Y", maxDate: "today" }}
//             value={dateRange.length ? dateRange : initialRange}
//             onChange={setDateRange}
//             className="form-control"
//           />
//           <i className="bx bx-calendar date-icon"></i>
//         </div>
//         <Col xs="4" lg="4" xxl="2">
//           <button
//             className="btn btn-primary w-100"
//             style={{ height: "38px" }}
//             onClick={handleApplyClick}
//           >
//             Apply
//           </button>
//         </Col>
//       </div>

//       {/* Table Container */}
//       <div
//         className="table-responsive"
//         ref={tableContainerRef}
//         style={{
//           height: "500px",
//           border: "1px solid #e9ecef",
//           borderRadius: "4px",
//           overflow: "hidden",
//           position: "relative"
//         }}
//       >
//         {tableLoading ? (
//           <Card className="m-0 text-muted h-100">
//             <CardBody className="d-flex align-items-center justify-content-center h-100">
//               <Spinner color="primary" />
//             </CardBody>
//           </Card>
//         ) : (
//           <div
//             className="table-wrapper"
//             style={{ height: "100%", width: "100%", position: "relative", overflow: "auto" }}
//           >
//             {/* Unified table structure with consistent column sizes */}
//             <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
//               {/* Table Header */}
//               <thead className={`bg-gl-primary sticky-header ${theadClass}`}
//                 style={{
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 2,
//                   boxShadow: "0 2px 3px rgba(0,0,0,0.1)"
//                 }}
//               >
//                 {table.getHeaderGroups().map((headerGroup) => (
//                   <tr key={headerGroup.id}>
//                     {headerGroup.headers.map((header) => {
//                       const isSorted = header.column.getIsSorted();
//                       const width = columnWidths.find(col => col.id === header.id)?.width;

//                       return (
//                         <th
//                           key={header.id}
//                           style={{
//                             width,
//                             minWidth: columnWidths.find(col => col.id === header.id)?.minWidth,
//                             padding: "0.75rem",
//                             fontWeight: "bold",
//                             color: "#fff",
//                             borderRight: "1px solid rgba(255,255,255,0.2)",
//                             textAlign: header.column.columnDef.headerTextAlign || "left",
//                             cursor: "pointer",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap"
//                           }}
//                           onClick={header.column.getToggleSortingHandler()}
//                         >
//                           <div className="d-flex align-items-center justify-content-between">
//                             {flexRender(
//                               header.column.columnDef.Header,
//                               header.getContext()
//                             )}
//                             {isSorted === "asc" ? (
//                               <i className="ms-2 bx bx-caret-up"></i>
//                             ) : isSorted === "desc" ? (
//                               <i className="ms-2 bx bx-caret-down"></i>
//                             ) : (
//                               <i className="ms-2 bx bxs-sort-alt"></i>
//                             )}
//                           </div>
//                         </th>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </thead>

//               {/* Table Body */}
//               <tbody className={tbodyClass}>
//                 {data?.length > 0 && table.getRowModel()?.rows?.length > 0 ? (
//                   table.getRowModel().rows.map((row) => (
//                     <tr key={row.id} style={{ borderBottom: "1px solid #e9ecef" }}>
//                       {row?.getVisibleCells()?.map((cell) => {
//                         const width = columnWidths.find(col => col.id === cell.column.id)?.width;

//                         return (
//                           <td
//                             key={cell.id}
//                             className="fs-p-bg fw-medium"
//                             style={{
//                               width,
//                               minWidth: columnWidths.find(col => col.id === cell.column.id)?.minWidth,
//                               padding: "0.75rem",
//                               borderRight: "1px solid #e9ecef",
//                               textAlign: cell.column.columnDef.bodyTextAlign || "left",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap"
//                             }}
//                           >
//                             {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={table.getAllColumns().length} className="p-4 text-center">
//                       <EmptyState />
//                     </td>
//                   </tr>
//                 )}
//               </tbody>

//               {/* Table Footer */}
//               {footer && (
//                 <tfoot
//                   className="bg-gl-success"
//                   style={{
//                     position: "sticky",
//                     bottom: 0,
//                     zIndex: 2,
//                     borderTop: "1px solid #e9ecef",
//                     boxShadow: "0 -2px 3px rgba(0,0,0,0.1)"
//                   }}
//                 >
//                   <tr>
//                     {table.getAllColumns().map((column, index) => {
//                       const width = columnWidths.find(col => col.id === column.id)?.width;

//                       // First 5 columns merged for "Total" label
//                       if (index === 0) {
//                         return (
//                           <td
//                             key={column.id}
//                             colSpan={5}
//                             style={{
//                               padding: "0.75rem",
//                               borderRight: "1px solid rgba(255,255,255,0.2)",
//                               textAlign: "end"
//                             }}
//                           >
//                             Total
//                           </td>
//                         );
//                       }
//                       // Purchase total in column 5
//                       else if (index === 5) {
//                         return (
//                           <td
//                             key={column.id}
//                             style={{
//                               width,
//                               minWidth: columnWidths.find(col => col.id === column.id)?.minWidth,
//                               padding: "0.75rem",
//                               borderRight: "1px solid rgba(255,255,255,0.2)",
//                               textAlign: "end"
//                             }}
//                           >
//                             {parseFloat(summaryData?.total_purchase ?? 0).toLocaleString("en-IN")}
//                           </td>
//                         );
//                       }
//                       // Sale total in column 7
//                       else if (index === 7) {
//                         return (
//                           <td
//                             key={column.id}
//                             style={{
//                               width,
//                               minWidth: columnWidths.find(col => col.id === column.id)?.minWidth,
//                               padding: "0.75rem",
//                               borderRight: "1px solid rgba(255,255,255,0.2)",
//                               textAlign: "end"
//                             }}
//                           >
//                             {parseFloat(summaryData?.total_sale ?? 0).toLocaleString("en-IN")}
//                           </td>
//                         );
//                       }
//                       // Empty cells for other columns
//                       else if (index > 4) {
//                         return (
//                           <td
//                             key={column.id}
//                             style={{
//                               width,
//                               minWidth: columnWidths.find(col => col.id === column.id)?.minWidth,
//                               padding: "0.75rem",
//                               borderRight: index < table.getAllColumns().length - 1 ? "1px solid rgba(255,255,255,0.2)" : "none",
//                               textAlign: "end"
//                             }}
//                           >
//                           </td>
//                         );
//                       }
//                       // This return is never reached because we've handled all cases above
//                       return null;
//                     })}
//                   </tr>
//                 </tfoot>
//               )}
//             </table>
//           </div>
//         )}
//       </div>
//     </Fragment>
//   );
// };

// export default TableContainerDateRangeFilter3;

import React, { useState, Fragment, useEffect, useRef, useMemo } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Input,
  Label,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { showToast } from "../ToastNotification";
import CommonLoading from "./CommonLoading";
import {
  adjustToWorkingDay,
  getCurrentFiscalYearDates,
} from "./WorkingDateRange";
import { useVirtualizer } from "@tanstack/react-virtual";

const TableContainerDateRangeFilter3 = ({
  footer,
  summary,
  columns,
  data,
  theadClass = "",
  tbodyClass = "",
  onDateRangeChange,
  type,
  dateRange,
  setDateRange,
  exchangeFilter,
  setExchangeFilter,
  selectedDate,
  setSelectedDate,
  yesterday,
}) => {
  // console.log("summary", summary, data);
  const [globalFilter, setGlobalFilter] = useState("");
  const [summaryData, setSummarydata] = useState(summary);
  const [sorting, setSorting] = useState([]);
  const { fyStart, fyEnd } = getCurrentFiscalYearDates();

  const [dynamicMaxDate, setDynamicMaxDate] = useState("today"); // Default max date is today
  const [tableLoading, setTableLoading] = useState(false);

  const tableContainerRef = useRef(null);

  // Minimum column width
  const MIN_COLUMN_WIDTH = 120;

  const convertToDateFormat = (dateString) => {
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const [day, month, year] = dateString.replace(",", "").split(" ");
    return `${day.padStart(2, "0")}-${months[month]}-${year}`;
  };

  const formatDate = (date) => {
    return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date?.getDate()).padStart(2, "0")}`;
  };
  // const convertToDateFormatYMD = (dateString) => {
  //   const months = {
  //     Jan: "01",
  //     Feb: "02",
  //     Mar: "03",
  //     Apr: "04",
  //     May: "05",
  //     Jun: "06",
  //     Jul: "07",
  //     Aug: "08",
  //     Sep: "09",
  //     Oct: "10",
  //     Nov: "11",
  //     Dec: "12",
  //   };

  //   const [day, month, year] = dateString.replace(",", "").split(" ");
  //   return `${year}-${months[month]}-${day.padStart(2, "0")}`;
  // };

  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      globalFilter,
      sorting,
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
  });

  const initialRange =
    summary?.start && summary?.end
      ? [convertToDateFormat(summary?.start), convertToDateFormat(summary?.end)]
      : [];

  const handleApplyClick = () => {
    const filteredArr = dateRange.filter((item) => item !== null);
    const formatDate = (date) => {
      return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date?.getDate()).padStart(2, "0")}`;
    };
    if (filteredArr?.length > 1) {
      setTableLoading(true);
      if (onDateRangeChange) {
        onDateRangeChange({
          start_date: formatDate(dateRange[0]),
          end_date: formatDate(dateRange[1]),
          exchangeFilter: exchangeFilter,
          setTableLoading,
        });
      }
    } else {
      setTableLoading(true);
      onDateRangeChange({
        start_date: formatDate(summary?.start),
        end_date: formatDate(summary?.end),
        exchangeFilter: exchangeFilter,
        setTableLoading,
      });
      // showToast("Please select a date range to filter", "error");
    }
  };

  const handleDateChange = (dates, dateStr, instance) => {
    if (dates.length === 0) return;
    const newDate = dates[0];

    // Get today's date with time set to 00:00:00
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Validate the selected date
    // if (newDate >= today) {
    //   showToast("You cannot select today's date or later!", 'error');

    //   instance.setDate(selectedDate, false);
    //   return;
    // }

    // Check if the selected date is a working day.
    // const dayOfWeek = newDate.getDay();
    // if (dayOfWeek === 0 || dayOfWeek === 6) {
    //   showToast("Please select a working day.", "error");
    //   instance.setDate(selectedDate, false);
    //   return;
    // }

    // Update the state with the newly selected valid date
    setSelectedDate(newDate);
  };

  useEffect(() => {
    setSummarydata(summary);
  }, [tableLoading, summary]);

  useEffect(() => {
    const rows = table.getRowModel().rows;
    if (rows.length > 0) {
      const totals = rows.reduce(
        (acc, item) => {
          acc.total_purchase += +item?.original.debit || 0;
          acc.total_sale += +item?.original.credit || 0;
          return acc;
        },
        {
          total_purchase: 0,
          total_sale: 0,
          start: summary?.start,
          end: summary?.end,
        }
      );
      setSummarydata(totals);
    }
  }, [table.getRowModel, globalFilter, tableLoading, summary]);

  // Compute column widths once for consistent sizing
  const columnWidths = useMemo(() => {
    const allColumns = table.getAllColumns();

    // Calculate total size units
    let totalSizeUnits = 0;
    allColumns.forEach((column) => {
      const size = column.columnDef.size || 1;
      totalSizeUnits += size;
    });

    // Calculate each column's percentage width
    return allColumns.map((column) => {
      const minWidth = column.columnDef.minSize || MIN_COLUMN_WIDTH;
      const size = column.columnDef.size || 1;
      const percentWidth = (size / totalSizeUnits) * 100;

      return {
        id: column.id,
        minWidth,
        percentWidth: `${percentWidth}%`,
        size,
      };
    });
  }, [table.getAllColumns()]);

  // Empty state component
  const EmptyState = () => (
    <Card className="m-0 text-muted">
      <CardBody>No Record Found</CardBody>
    </Card>
  );

  const rows = table.getRowModel().rows;

  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => 45,
    overscan: 10,
  });

  const virtualRows = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();

  const paddingTop = virtualRows.length > 0 ? virtualRows[0].start : 0;
  const paddingBottom =
    virtualRows.length > 0
      ? totalSize - virtualRows[virtualRows.length - 1].end
      : 0;

  return (
    <Fragment>
      {/* Search and Date Filter */}
      <div className="mb-2 row">
        <Col
          sm="12"
          md={"6"}
          lg="6"
          xl="3"
          xxl="4"
          className=" mb-2 mb-xl-0 mb-xxl-0"
        >
          <div className="search-box position-relative d-inline-block w-100">
            <input
              id="search-bar-0"
              type="text"
              className="form-control"
              style={{
                backgroundColor: "#F1F4F7",
                border: "1px solid transparent",
                height: "38px",
                paddingLeft: "2.5rem",
              }}
              placeholder="Search by Scrip Name"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
            <i
              className="bx bx-search-alt search-icon"
              style={{
                position: "absolute",
                left: "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6c757d",
              }}
            ></i>
          </div>
        </Col>
        <Col
          sm="12"
          md={"6"}
          lg="6"
          xl="4"
          xxl="4"
          className=" mb-2 mb-xl-0 mb-xxl-0"
        >
          <div className="d-flex justify-content-evenly align-items-center">
            <Label
              htmlFor="type"
              className="form-label d-flex align-items-center  m-0 me-1 text-dark fs-14 fw-medium"
            >
              Select Report Type:
            </Label>
            <Input
              type="select"
              id="type"
              name="type"
              className="form-control"
              style={{
                backgroundColor: "#F1F4F7",
                border: "1px solid transparent",
                height: "38px",
                width: "calc(100% - 160px)",
              }}
              // placeholder="Search..."
              value={exchangeFilter}
              onChange={(e) => setExchangeFilter(e.target.value)}
            >
              <option value={""}>Combined</option>
              <option value={"NSE"}>NSE</option>
              <option value={"BSE"}>BSE</option>
            </Input>
          </div>
        </Col>
        <div className="date-box d-inline-block col-xxl-3 col-xl-3 col-lg-8 col-md-8 col-12 mb-xl-0 mb-xxl-0  mb-2">
          <div className="d-flex justify-content-evenly align-items-center">
            <Label
              htmlFor="type"
              className="form-label d-flex align-items-center me-1  m-0 text-dark fs-14 fw-medium text-nowrap"
            >
              Select Date:
            </Label>
            <Flatpickr
              style={{
                backgroundColor: "#F1F4F7",
                border: "1px solid transparent",
                width: "calc(100% - 100px)",
              }}
              options={{
                mode: "single",
                dateFormat: "d-m-Y",
                minDate: fyStart,
                maxDate: new Date(
                  Math.min(
                    fyEnd,
                    new Date(new Date().setDate(new Date().getDate()))
                  )
                ),
              }}
              value={selectedDate}
              onChange={handleDateChange}
              className="form-control"
            />
          </div>
          <i
            className="bx bx-calendar date-icon"
            style={{
              height: "100%",
            }}
          ></i>
        </div>
        <Col
          sm="12"
          md="4"
          lg="4"
          xl="2"
          xxl="1"
          className="mb-xl-0 mb-xxl-0  mb-2"
        >
          <button
            className="btn btn-primary w-100"
            style={{ height: "38px" }}
            onClick={handleApplyClick}
          >
            Apply
          </button>
        </Col>
      </div>

      {/* Table Container with Horizontal Scroll */}
      <div
        className="table-responsive"
        ref={tableContainerRef}
        style={{
          // minHeight: "150px",
          maxHeight: "65vh", // Maximum height for many rows
          border: "1px solid #e9ecef",
          borderRadius: "4px",
          overflow: "auto",
          position: "relative",
        }}
      >
        {tableLoading ? (
          <Card className="m-0 text-muted h-100">
            <CardBody className="d-flex align-items-center justify-content-center h-100">
              <CommonLoading
                style={{
                  maxHeight: "6vh",
                }}
              />
            </CardBody>
          </Card>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "800px",
            }}
          >
            {/* Table Header */}
            <thead
              className={`bg-gl-primary sticky-header ${theadClass}`}
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2,
                boxShadow: "0 2px 3px rgba(0,0,0,0.1)",
              }}
            >
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header, index) => {
                    const isSorted = header.column.getIsSorted();
                    const colWidth = columnWidths.find(
                      (col) => col.id === header.id
                    );

                    return (
                      <th
                        key={header.id}
                        style={{
                          width: colWidth?.percentWidth,
                          minWidth: `${colWidth?.minWidth}px`,
                          padding: "0.4rem",
                          fontWeight: "bold",
                          color: "#fff",
                          borderRight:
                            index < headerGroup.headers.length - 1
                              ? "1px solid rgba(255,255,255,0.2)"
                              : "none",
                          textAlign:
                            header.column.columnDef.headerTextAlign || "left",
                          cursor: "pointer",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                        }}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          {flexRender(
                            header.column.columnDef.Header,
                            header.getContext()
                          )}
                          {isSorted === "asc" ? (
                            <i className="ms-2 bx bx-caret-up"></i>
                          ) : isSorted === "desc" ? (
                            <i className="ms-2 bx bx-caret-down"></i>
                          ) : (
                            <i className="ms-2 bx bxs-sort-alt"></i>
                          )}
                        </div>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>

            {/* Table Body */}
            {/* Table Body */}
            <tbody className={tbodyClass}>
              {data?.length > 0 && rows.length > 0 ? (
                <>
                  {paddingTop > 0 && (
                    <tr>
                      <td
                        colSpan={table.getAllColumns().length}
                        style={{
                          height: `${paddingTop}px`,
                          padding: 0,
                          border: "none",
                        }}
                      />
                    </tr>
                  )}
                  {virtualRows.map((virtualRow) => {
                    const row = rows[virtualRow.index];
                    return (
                      <tr
                        key={row.id}
                        style={{ borderBottom: "1px solid #e9ecef" }}
                      >
                        {row.getVisibleCells().map((cell, index) => {
                          const colWidth = columnWidths.find(
                            (col) => col.id === cell.column.id
                          );
                          const cellValue = cell.getContext().getValue();

                          // Format number if cellValue is a number
                          const formattedValue =
                            typeof cellValue === "number"
                              ? cellValue.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : cellValue;

                          return (
                            <td
                              key={cell.id}
                              className="fs-p-bg fw-medium"
                              style={{
                                width: colWidth?.percentWidth,
                                minWidth: `${colWidth?.minWidth}px`,
                                padding: "0.3rem",
                                paddingLeft: "0.4rem",
                                borderRight:
                                  index < row.getVisibleCells().length - 1
                                    ? "1px solid #e9ecef"
                                    : "none",
                                textAlign:
                                  cell.column.columnDef.bodyTextAlign || "left",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                                ...(cell.column.id === "scrip_name"
                                  ? cell.column.columnDef.meta?.style
                                  : {}),
                              }}
                            >
                              {formattedValue}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  {paddingBottom > 0 && (
                    <tr>
                      <td
                        colSpan={table.getAllColumns().length}
                        style={{
                          height: `${paddingBottom}px`,
                          padding: 0,
                          border: "none",
                        }}
                      />
                    </tr>
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan={table.getAllColumns().length}
                    className="p-4 text-center"
                  >
                    <EmptyState />
                  </td>
                </tr>
              )}
            </tbody>

            {/* Table Footer */}
            {footer && type === "CAP" && (
              <tfoot
                className="bg-gl-success fw-bold"
                style={{
                  position: "sticky",
                  bottom: "-1px",
                  zIndex: 2,
                  borderTop: "1px solid #e9ecef",
                  boxShadow: "0 -2px 3px rgba(0,0,0,0.1)",
                }}
              >
                <tr>
                  {columnWidths.map((colWidth, index) => {
                    // Calculate colspan for the "Total" cell
                    const totalLabelColspan = 5;

                    if (index === 0) {
                      return (
                        <td
                          key={`footer-${index}`}
                          colSpan={totalLabelColspan}
                          style={{
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "start",
                          }}
                        >
                          TOTAL
                        </td>
                      );
                    } else if (index === 5) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(
                            summaryData?.total_purchase ?? 0
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      );
                    } else if (index === 7) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(summaryData?.total_sale ?? 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      );
                    } else if (index >= totalLabelColspan) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight:
                              index < columnWidths.length - 1
                                ? "1px solid rgba(255,255,255,0.2)"
                                : "none",
                            textAlign: "end",
                          }}
                        ></td>
                      );
                    }
                    return null;
                  })}
                </tr>
              </tfoot>
            )}
            {footer && type === "FO" && (
              <tfoot
                className="bg-gl-success fw-bold"
                style={{
                  position: "sticky",
                  bottom: "-1px",
                  zIndex: 2,
                  borderTop: "1px solid #e9ecef",
                  boxShadow: "0 -2px 3px rgba(0,0,0,0.1)",
                }}
              >
                <tr>
                  {columnWidths.map((colWidth, index) => {
                    // Calculate colspan for the "Total" cell
                    const totalLabelColspan = 9;

                    if (index === 0) {
                      return (
                        <td
                          key={`footer-${index}`}
                          colSpan={totalLabelColspan}
                          style={{
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "start",
                          }}
                        >
                          TOTAL
                        </td>
                      );
                    } else if (index === 9) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(
                            summaryData?.total_purchase ?? 0
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      );
                    } else if (index === 10) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(summaryData?.total_sale ?? 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      );
                    } else if (index >= totalLabelColspan) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight:
                              index < columnWidths.length - 1
                                ? "1px solid rgba(255,255,255,0.2)"
                                : "none",
                            textAlign: "end",
                          }}
                        ></td>
                      );
                    }
                    return null;
                  })}
                </tr>
              </tfoot>
            )}
            {footer && type === "COM" && (
              <tfoot
                className="bg-gl-success fw-bold"
                style={{
                  position: "sticky",
                  bottom: "-1px",
                  zIndex: 2,
                  borderTop: "1px solid #e9ecef",
                  boxShadow: "0 -2px 3px rgba(0,0,0,0.1)",
                }}
              >
                <tr>
                  {columnWidths.map((colWidth, index) => {
                    // Calculate colspan for the "Total" cell
                    const totalLabelColspan = 10;

                    if (index === 0) {
                      return (
                        <td
                          key={`footer-${index}`}
                          colSpan={totalLabelColspan}
                          style={{
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "start",
                          }}
                        >
                          TOTAL
                        </td>
                      );
                    } else if (index === 9) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(
                            summaryData?.total_purchase ?? 0
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      );
                    } else if (index === 10) {
                      return (
                        <td
                          key={`footer-${index}`}
                          style={{
                            width: colWidth.percentWidth,
                            minWidth: `${colWidth.minWidth}px`,
                            padding: "0.75rem",
                            borderRight: "1px solid rgba(255,255,255,0.2)",
                            textAlign: "end",
                          }}
                        >
                          {Number(summaryData?.total_sale ?? 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      );
                    }
                    return null;
                  })}
                </tr>
              </tfoot>
            )}
          </table>
        )}
      </div>
    </Fragment>
  );
};

export default TableContainerDateRangeFilter3;
